import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const TrackingBaseUrl = '/tracking/shipment'

export const queryShipmentTrackingRecords = async params => {
  const result = await request({
    url: TrackingBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search shipment records failed!')?.data ?? []
}

export const queryShipmentPallets = async shipmentId => {
  const result = await request({
    url: TrackingBaseUrl + '/' + shipmentId + '/pallets',
    method: 'GET'
  })
  return ResultHandler(result, 'Search shipment pallets failed!')?.pallets ?? []
}

export const deleteShipmentTrackingRecord = async recordId => {
  const result = await request({
    url: TrackingBaseUrl + '/record/' + recordId,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Search address failed!') ?? false
}

export const updateTrackingRecord = async record => {
  const result = await request({
    url: TrackingBaseUrl + '/record/' + record.recordId,
    method: 'PUT',
    data: record
  })
  return ResultHandler(result)
}

export const createTrackingRecord = async record => {
  const result = await request({
    url: TrackingBaseUrl + '/record',
    method: 'POST',
    data: record
  })
  return ResultHandler(result)
}
